import { createContext, useContext, useEffect, useState } from 'react'
import { useAuthStore } from '../services/authStore'
import { fetchTranslations, getStoredLocale, setLocale, translate as translateFn } from '../services/translationService'

const TranslationContext = createContext({
  t: (key, fallback) => key,
  locale: 'en',
  setLang: () => {},
  translations: {},
  loading: false,
})

export function TranslationProvider({ children }) {
  const { user } = useAuthStore()
  const initialLocale = getStoredLocale() || user?.default_language || 'en'
  const [locale, setLocaleState] = useState(initialLocale)
  const [translations, setTranslations] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      try {
        const items = await fetchTranslations(locale)
        setTranslations(items)
      } catch (error) {
        console.error('Translation load failed', error)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [locale])

  useEffect(() => {
    if (!getStoredLocale() && user?.default_language && user.default_language !== locale) {
      setLocale(user.default_language)
      setLocaleState(user.default_language)
    }
  }, [user, locale])

  const setLang = (newLocale) => {
    setLocale(newLocale)
    setLocaleState(newLocale)
  }

  const t = (key, fallback = '') => {
    if (translations[key]) {
      return translations[key]
    }
    return fallback || key
  }

  return (
    <TranslationContext.Provider value={{ t, locale, setLang, translations, loading }}>
      {children}
    </TranslationContext.Provider>
  )
}

export function useTranslation() {
  return useContext(TranslationContext)
}
